import { render, staticRenderFns } from "./difference_detail.vue?vue&type=template&id=c5162c34&scoped=true&"
import script from "./difference_detail.vue?vue&type=script&lang=js&"
export * from "./difference_detail.vue?vue&type=script&lang=js&"
import style0 from "./difference_detail.vue?vue&type=style&index=0&id=c5162c34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5162c34",
  null
  
)

export default component.exports